module.exports = __webpack_public_path__ + "static/media/breakfast3.f0312e34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/home/breakfast/images/breakfast3.jpg
// module id = 645
// module chunks = 0